'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _bindings = require('./bindings');

var init = exports.init = function init() {
  (0, _bindings.bindActions)();
}; // import 'styles/components/overlay.scss';